theme.CartTemplateSection = new function () {
  this.onSectionLoad = function (container) {
    this.$container = $(container);

    // listen to cart changes
    $(document).on('theme:cartchanged.cartTemplateSection', this.functions.refreshCartDependentContent.bind(this));

    // terms and conditions checkbox
    if ($('#cartform input#terms', container).length > 0) {
      $(document).on('click.cartTemplateSection', '#cartform [name="checkout"], .additional-checkout-buttons input, a[href*="/checkout"]', function () {
        if ($('#cartform input#terms:checked').length == 0) {
          alert(theme.strings.cart_terms_confirmation);
          return false;
        }
      });
    }

    if ($(container).data('ajax-update')) {
      $(container).on('keyup.cartTemplateSection change.cartTemplateSection changeFromButton.cartTemplateSection', '.cart-item__quantity-input', function (evt) {
        if (this.replacingContent) {
          return;
        }
        if ($(evt.currentTarget).data('initial-value') && $(evt.currentTarget).data('initial-value') == $(evt.currentTarget).val()) {
          return;
        }
        if ($(evt.currentTarget).val().length == 0 || $(evt.currentTarget).val() == '0') {
          return;
        }
        if (!evt.currentTarget.reportValidity()) {
          return;
        }

        // focus on -/+ button or input, depending on source of event
        var toFocusId;
        if (evt.type === 'changeFromButton') {
          toFocusId = $(evt.data).attr('id');
        } else {
          toFocusId = $(evt.currentTarget).attr('id');
        }

        this.functions.updateCart.call(this,
        {
          line: $(evt.currentTarget).data('line'),
          quantity: $(evt.currentTarget).val() },
        function () {
          // after update, set focus
          $('#' + toFocusId).focus();
        });

      }.bind(this));

      $(container).on('click.cartTemplateSection', '.quantity-down, .quantity-up', function (evt) {
        var $input = $(this).closest('.quantity').find('input'),
        step = $input.attr('step') ? parseInt($input.attr('step')) : 1;
        if ($(this).hasClass('quantity-down')) {
          $input.val(parseInt($input.val()) - step).trigger('changeFromButton', { data: this });
        } else {
          $input.val(parseInt($input.val()) + step).trigger('changeFromButton', { data: this });
        }
        return false;
      });
    }

    theme.cartNoteMonitor.load($('.checkout-note [name="note"]', container));

    $(container).on('click.cartTemplateSection', 'button[data-toggle-shipping]', function () {
      $('#shipping-calculator').toggle();
      var alt = $(this).data('toggle-html');
      $(this).data('toggle-html', $(this).html());
      $(this).html(alt);
      return false;
    });
  };

  this.functions = {
    refreshCartDependentContent: function refreshCartDependentContent() {
      if (this.cartRefreshXhr) {
        this.cartRefreshXhr.abort();
      }
      // fetch new html for the page
      this.cartRefreshXhr = $.ajax({
        type: 'GET',
        url: theme.routes.cart_url,
        success: function (data) {
          var toReplace = ['.cart-item-list', '.checkout-subtotal-container__dynamic'];
          var $newDom = $('<div>' + data + '</div>');

          // remove any transitions
          $newDom.find('.fade-in').removeClass('fade-in');
          $newDom.find('[data-cc-animate]').removeAttr('data-cc-animate');

          for (var i = 0; i < toReplace.length; i++) {
            this.replacingContent = true; // to avoid triggering change events when focus is lifted before DOM replacement
            var $toReplace = this.$container.find(toReplace[i]),
            $replaceWith = $newDom.find(toReplace[i]);
            // preserve loaded images
            $replaceWith.find('.cart-item__image').each(function () {
              var $match = $toReplace.find('#' + this.id);
              if ($match.length) {
                $(this).replaceWith($match.clone());
              }
            });
            $toReplace.replaceWith($replaceWith);
            this.replacingContent = false;
          }
        }.bind(this),
        error: function error(data) {
          if (data.statusText != 'abort') {
            console.log('Error refreshing page');
            console.log(data);
          }
        },
        complete: function () {
          this.cartRefreshXhr = null;
        }.bind(this) });

    },

    updateCart: function updateCart(params, successCallback) {
      if (this.cartXhr) {
        this.cartXhr.abort();
      }
      if (this.cartRefreshXhr) {
        this.cartRefreshXhr.abort();
      }
      this.cartXhr = $.ajax({
        type: 'POST',
        url: theme.routes.cart_change_url + '.js',
        data: params,
        dataType: 'json',
        success: function success() {
          document.documentElement.dispatchEvent(
          new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));

          successCallback();
        },
        error: function error(data) {
          if (data.statusText != 'abort') {
            console.log('Error processing update');
            console.log(data);
          }
        },
        complete: function () {
          this.cartXhr = null;
        }.bind(this) });

    } };


  this.onSectionUnload = function (container) {
    $(document).off('.cartTemplateSection');
    $(container).off('.cartTemplateSection');
    theme.cartNoteMonitor.unload($('.checkout-note [name="note"]', container));
  };
}();
theme.Sections.register('cart-template', theme.CartTemplateSection, { deferredLoad: false });
